import React from 'react'
import store from '../../store/Store'

import actions from '../../actions/Actions'

import './pageSelection.scss'

type pageSelectionState = {
	article: any;
}

type pageSelectionProps = {
	article: any;
}

let draggable

class PageSelection extends React.Component<pageSelectionState, pageSelectionProps> {

  constructor(props) {
  	super(props)

  	this.state = {
  		article: props.article
  	}
  }

  componentDidMount() {
	store.subscribe(() => {
		this.setState({
			article: store.getState().article
		})
	})
  }

  componentWillUnmount() {
	store.subscribe(() => {
		this.setState({
			article: store.getState().article
		})
	})
  }

  onDrag = (event) => {
  	console.log('onDrag')
  	console.log(event)
  }

  onDragStart = (event) => {
  	console.log('onDragStart')
  	console.log(event)

  	draggable = event.target

  	event.dataTransfer.effectAllowed = 'move'
  	event.dataTransfer.setData('text/html', event.target.outerHTML);

  	event.target.classList.add('draggable')
  }

  onDragEnter = (event) => {
  	console.log('onDragEnter')
  	console.log(event)
  }

  onDragOver = (event) => {
  	console.log('onDragOver')
  	console.log(event)

  	event.preventDefault ? event.preventDefault() : null

  	event.target.classList.add('draggableOver')

  	event.dataTransfer.dropEffect = 'move'

  	console.log('INSERT BEFORE: ' + event.target.id)
  	console.log('INSERT BETWEEN: ' + (event.target.id - 1) + ' AND ' + event.target.id)

  	return false
  }

  onDragLeave = (event) => {
  	console.log('onDragLeave')
  	console.log(event)

  	event.target.classList.remove('draggableOver')
  }

  onDrop = (event) => {
  	console.log('onDrop')
  	console.log(event)

  	const { article } = this.state

  	event.stopPropagation ? event.stopPropagation() : null

  	console.log(this)

  	event.target.classList.remove('draggableOver')

  	if (draggable !== event.target) {
  		console.log('Different Item')

  		console.log('Move Item: ' + draggable.id + ' To: ' + event.target.id)

  		let draggableId = draggable.id
  		let eventTargetId = event.target.id

  		draggableId = parseInt(draggableId)
  		eventTargetId = parseInt(eventTargetId)

  		if ((eventTargetId + 1) === draggableId || (eventTargetId - 1) === draggableId) {
  			actions.articleActions.pageSwap({
  				source: draggableId,
  				destination: eventTargetId
  			})
  		} else {
  			actions.articleActions.pageRearrange({
  				source: draggableId,
  				destination: eventTargetId
  			})
  		}

  		/*console.log('Remove and Read AddPage')
  		let pageBox = document.getElementById('PageBox')
  		console.log(pageBox)
  		let pageBoxListItems = pageBox.querySelectorAll('li')
  		console.log(pageBoxListItems)
  		let addPage
  		pageBoxListItems.forEach((item, index) => {
  			if (item.id === 'addPage') {
  				addPage = item
  				event.target.parentNode.removeChild(item)
  			}
  		})  		
  		
  		console.log('Remove and Read Draggable')
  		event.target.parentNode.removeChild(draggable)
	    let dropHTML = event.dataTransfer.getData('text/html')

	    console.log(dropHTML)

	    event.target.insertAdjacentHTML('beforebegin', dropHTML)
	    let droppable = event.target.previousSibling

	    /*let droppable

	    droppable.push(
	    	<li
				className={ 'PageBoxItem' }
				id={ addPage.id }
				key={ addPage.id }
				style={{
					width: '10px',
					height: '10px',
					borderRadius: '5px',
					margin: '8px 0',
					color: 'rgba(155, 155, 155, 1)',
					backgroundColor: 'rgba(155, 155, 155, 1)'
				}}
				draggable={ true }
				onDrag={ this.onDrag.bind(this) }
				onDragStart={ this.onDragStart.bind(this) }
				onDragEnter={ this.onDragEnter.bind(this) }
				onDragOver={ this.onDragOver.bind(this) }
				onDragLeave={ this.onDragLeave.bind(this) }
				onDrop={ this.onDrop.bind(this) }
				onDragEnd={ this.onDragEnd.bind(this) }
				onClick={ () => { actions.articleActions.changePreviousPage(table.info.currentPage); actions.articleActions.changeCurrentPage(addPage.id) }}
			/>
	    )*/

	    /*event.target.parentNode.appendChild(droppable)

	    console.log('Remove and Read AddPage')
	    event.target.parentNode.appendChild(addPage)*/
	}

  	return false
  }

  onDragEnd = (event) => {
  	console.log('onDragEnd')
  	console.log(event)

  	event.target.classList.remove('draggable')
  }

  render() {
  	  const {
  	  	article
  	  } = this.state;

	  return (
	  	<div
	  		className='PageSelection'
	  		style={{
  				position: 'fixed',
				top: '0', /* 'calc(50px + (${ table.info.currentPage } * 100%))', */
				left: '0'
  			}}
	  	>
	  		<ul
	  			className='PageBox'
	  			id='PageBox'
	  		>

		  		{
		  			article.pages.map((page, index, array) => {

		  				return (
		  					<li
		  						className={ 'PageBoxItem' }
		  						id={ index }
		  						key={ index }
		  						style={{
									width: '10px',
									height: '10px',
									borderRadius: '5px',
									margin: '8px 0',
									color: 'rgba(99, 99, 99, 1)',
									backgroundColor: article.info.currentPage === index ? 'rgba(99, 99, 99, 1)' : article.info.previousPage === index ? 'rgba(155, 155, 155, 1)' : 'rgba(231, 231, 231, 1)',
		  						}}
		  						draggable={ true }
		  						onDrag={ this.onDrag.bind(this) }
		  						onDragStart={ this.onDragStart.bind(this) }
		  						onDragEnter={ this.onDragEnter.bind(this) }
		  						onDragOver={ this.onDragOver.bind(this) }
		  						onDragLeave={ this.onDragLeave.bind(this) }
		  						onDrop={ this.onDrop.bind(this) }
		  						onDragEnd={ this.onDragEnd.bind(this) }
		  						onClick={ () => { actions.articleActions.changePreviousPage(article.info.currentPage); actions.articleActions.changeCurrentPage(index) }}
		  					/>
		  				)
		  					
		  			})
		  		}

		  		<li
					key={ 'add' }
					id={ 'addPage' }
					className={ 'AddPage' }
					style={{
						position: 'absolute',
						width: '8px',
						height: '8px',
						borderRadius: '5px',
						margin: '0',
						color: 'rgba(255, 255, 255, 1)'
					}}
					onClick={ () => { actions.articleActions.addPage(article.info.currentPage) }}
				/>

		  	</ul>
		</div>
	  );
	}
}

export default PageSelection;